import React from "react";
import styled from "styled-components";
import ArticlesExplorer from "../components/pageSection/ArticlesExplorer";
import useAuth from "../hooks/useAuth";
import PageContainer from "../components/containers/PageContainer";
import Title from "../components/text/Title";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 0;
`;

const DescriptionHeader = styled.p`
  color: #fff;
  font-family: "Sharp Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  padding: 0;
  span {
    color: #ff734f;
    font-weight: 700;
  }
`;

const Header = styled.div`
  display: flex;
  height: 135px;
  padding: 0px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 5px;
  align-self: stretch;
  border-radius: 19px;
  background: #232129;
  width: calc(100% - 80px);
  box-sizing: border-box;
  width: 100%;
  position: relative;
`;

const TitleHeader = styled.h1`
  color: #fff;
  font-family: "Sharp Sans";
  font-size: 28px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  margin: 0;
  padding: 0;
`;

const SuggestedFiles: React.FC = () => {
  const { user } = useAuth();

  if (!user?.user_id) {
    return <div>Error: User not found</div>;
  }

  return (
    <PageContainer>
      <Header>
        <TitleHeader>Textes</TitleHeader>
        <DescriptionHeader>
          Retrouvez ici tous les textes qui pourraient vous intéresser.
        </DescriptionHeader>
      </Header>
      <Container>
        <ArticlesExplorer userId={user.user_id} notFollowed={true} />
      </Container>
    </PageContainer>
  );
};

export default SuggestedFiles;
